import React from 'react';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  glowColor?: 'cyan' | 'teal' | 'blue' | 'green' | 'amber' | 'none';
  hover?: boolean;
}
export function GlassCard({
  children,
  className = '',
  glowColor = 'cyan',
  hover = true
}: GlassCardProps) {
  const glowStyles = {
    cyan: 'hover:border-cyan-500/40 hover:shadow-[0_0_30px_-5px_rgba(34,211,238,0.15)]',
    teal: 'hover:border-teal-500/40 hover:shadow-[0_0_30px_-5px_rgba(45,212,191,0.15)]',
    blue: 'hover:border-blue-500/40 hover:shadow-[0_0_30px_-5px_rgba(59,130,246,0.15)]',
    green: 'hover:border-green-500/40 hover:shadow-[0_0_30px_-5px_rgba(34,197,94,0.15)]',
    amber: 'hover:border-amber-500/40 hover:shadow-[0_0_30px_-5px_rgba(245,158,11,0.15)]',
    none: ''
  };
  const baseStyles = 'bg-white/[0.02] backdrop-blur-xl border border-white/10 rounded-2xl p-6 transition-all duration-500';
  const hoverStyles = hover ? `hover:bg-white/[0.04] ${glowStyles[glowColor]}` : '';
  return <div className={`${baseStyles} ${hoverStyles} ${className}`} data-id="element-210">
      {children}
    </div>;
}